import { OutlinedButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";
import { memo } from "react";

/**
 * Card for adjusting upcoming meal plans
 */
export const UpcomingPlansCard = memo(function UpcomingPlansCard() {
  const router = useIonRouter();

  const handleChangePlan = () => {
    router.push("/plans/my-plan", "forward");
  };

  return (
    <div
      className={cn(
        "bg-screen-gs-1 flex flex-col items-center gap-10 rounded-4xl py-8",
        "shadow-lg shadow-[#631db940]",
      )}
    >
      {/* Title */}
      <h3 className={cn(textVariants.title3, "text-center text-white")}>
        Got plans coming up? <br /> I can adjust things 😊
      </h3>

      {/* Change Plan Button */}
      <OutlinedButton color="white" onClick={handleChangePlan} textCase="normal" className="w-fit">
        Change plan
      </OutlinedButton>
    </div>
  );
});
